/** `detail.code` of a `party_protection` event (design §40.12.2). */
export const PARTY_PROTECTION_EVENT_CODE = [
    "rejected",
    "refused",
    "silent_start_ended",
    "longest_conversation_reached",
    "final_minute_said",
];
/** `detail.code` of a `party_confirmation` event (design §40.12.2; glossary §6.44's further names). */
export const PARTY_CONFIRMATION_EVENT_CODE = [
    "code_requested",
    "code_sent",
    "code_pending",
    "code_refused",
    "code_wrong",
    "code_expired",
    "confirmation_locked",
    "confirmed",
    "capability_refused",
    "recording_blanked",
    "passcode_asked",
    "passcode_wrong",
    "passcode_locked",
    "signed_visitor_confirmed",
];
/** Where an attempt's digits came from (design §40.9.5): the keypad, a typed chat message, or speech. */
export const PARTY_CONFIRMATION_SOURCE = ["keypad", "typed", "speech"];
/** `detail.code` of a `voice_agent_pass` event (design §33.10.2). */
export const VOICE_AGENT_PASS_EVENT_CODE = ["pass_started", "pass_completed", "pass_refused", "pass_back_completed"];
//# sourceMappingURL=conversation.js.map